import _ from 'lodash';
import { processNodes } from 'react-html-parser';
/**
 * ノードからテキストを取得
 * @param checkNode
 * @returns {string}
 */
export const getText = (checkNode) => (_.get(checkNode, 'children.0.data') || '').trim();
/**
 * ノードの親を取得
 * @param checkNode
 * @returns {string}
 */
export const getParentNodeName = (checkNode) => (_.get(checkNode, 'parent.name') || '').trim();
/**
 * 子要素を取得
 * @param checkNode
 * @param transform
 * @returns {React.Element[]|*}
 */
export const getChildrenElements = (checkNode, transform) => processNodes(_.get(checkNode, 'children'), transform);
/**
 * jsonフォーマットの要素を取得
 * @param text
 * @returns {{type}|any|null}
 */
export const getParseJson = (text) => {
    try {
        const jsonMatch = text.match(/^\[\[.+({"type":.+}).+]]$/);
        if (jsonMatch && jsonMatch.length === 2) {
            const json = JSON.parse(jsonMatch[1]);
            if (json.type) {
                return json;
            }
        }
    }
    catch (e) {
        // ignore
    }
    return null;
};
